import { bsConstants } from '../../module.constants'

/**
 * The website an author gives in the checkout's Business Info step, as it is stored [sc-29190], or
 * undefined when it isn't one: blank, with a space in it, with no dot in its host, or too long for the
 * column. A missing scheme is read as https, so "riverbendpress.com" is accepted as typed.
 *
 * The step and the API both judge the value here, so the step never accepts one the API then refuses.
 */
export const normalisePublisherWebsite = (value?: string | null): string | undefined => {
  const trimmed = (value || '').trim()
  if (!trimmed || /\s/.test(trimmed)) {
    return void 0
  }

  const website = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`
  if (website.length > bsConstants.SUBSCRIPTIONS.PLANS.PUBLISHER.APPLICATION.WEBSITE_MAX_LENGTH) {
    return void 0
  }

  try {
    const labels = new URL(website).hostname.split('.')
    return labels.length > 1 && labels.every(Boolean) ? website : void 0
  } catch {
    return void 0
  }
}
